import { useDispatch, useSelector } from "react-redux";
import { authUserSelector } from "../../redux/selectors/authSelector";
import {
  useGetLastReleasePlayingQuery,
  useGetPodcastsQuery,
} from "../../api/podcastsApi";
import { useEffect } from "react";
import {
  pause,
  playMedia,
  setCurrentContent,
  setProgress,
} from "../../redux/Slice/playerSlice";
import { setPlaylistReleases } from "../../redux/Slice/playlistReleasesSlice";

export const usePlayerInit = () => {
  const user = useSelector(authUserSelector);

  const { data: lastReleasePlaying } = useGetLastReleasePlayingQuery(null, {
    skip: !user.email,
  });

  // Второй запрос — данные подкаста, только если есть id из первого запроса
  const {
    data: playingReleasePodcast,
    isLoading: playingReleasePodcastLoading,
  } = useGetPodcastsQuery(
    { id: lastReleasePlaying?.podcastId },
    {
      skip:
        !lastReleasePlaying?.podcastId || !lastReleasePlaying?.podcastTrackId, // пропускаем, пока нет id
    },
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (!playingReleasePodcast || playingReleasePodcastLoading) {
      return;
    }

    const { podcastReleases } = playingReleasePodcast;

    if (!podcastReleases?.length) {
      return;
    }

    const release = podcastReleases.find(
      (item) => item.id === lastReleasePlaying.podcastTrackId,
    );

    if (!release) {
      return;
    }

    dispatch(setCurrentContent(release));
    dispatch(setPlaylistReleases(podcastReleases));
    dispatch(playMedia(release.audioFileLink));
    dispatch(pause());
    dispatch(setProgress(lastReleasePlaying.duration));
  }, [
    playingReleasePodcast,
    playingReleasePodcastLoading,
    lastReleasePlaying,
    dispatch,
  ]);
};
